import { useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import { CustomNumberInput, Modal } from '..';

const GenerarEtiquetas = ({ onClose, onConfirm }) => {
  const [quantity, setQuantity] = useState(0);

  return <Box display='flex' flexDirection='column' padding={0} margin={0}>
    <Box
      display='flex'
      flexDirection='column'
      sx={{ padding: 3 }}
    >
      <Box>
        {/* <Box display='flex' flexDirection='row' justifyContent="space-between" marginY={1}>
          <strong>Nuevo Pedido</strong>
        </Box > */}

        <Box display='flex' flexDirection='row' gap={2} marginY={2}>
          <CustomNumberInput
            id="quantity"
            label='Cantidad'
            minimo={0}
            maximo={200}
            value={quantity}
            onChange={(event, newValue) => {
              event.preventDefault();
              setQuantity(newValue)
            }}
            incrementsButtons
          />
        </Box>
        <TextField
          id="description"
          label="Descripción"
          type="text"
          variant="outlined"
          fullWidth
          value={"Cantidad de etiquetas a generar"}
          multiline
          maxRows={5}
          sx={{ marginY: 1 }}
        />
      </Box>
      <Box sx={{ mt: 5, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Button
          type="submit"
          variant="outlined"
          onClick={onClose}
        >Cancelar</Button>
        <Button
          type="submit"
          variant="outlined"
          disabled={quantity === 0}
          onClick={() => onConfirm && onConfirm(quantity)}
        >Guardar</Button>
      </Box>
    </Box>
  </Box>
}

export default GenerarEtiquetas;